<div class="container-fluid">
  <div class="main-layout">
    <nz-spin [nzSpinning]="this.loadingChart" style="flex: 1 1 75%">
      @if (this.options) {
        <div
          #graph
          echarts
          id="graph-div"
          [options]="options"
          [loading]="this.loadingChart"
          style="
            background-color: white;
            border-radius: 5px;
            padding: 10px;
            height: 70vh;
          "
          class="demo-chart"
          (chartInit)="chartInit($event)"
        ></div>
      }

      @for (opt of this.heatmapOptions; track opt) {
        <div
          echarts
          [options]="opt"
          [loading]="this.loadingChart"
          style="
            background-color: white;
            border-radius: 5px;
            padding: 10px;
            height: 70vh;
          "
        ></div>
      }

      @if (frequencyData && linePlotXConfig == 'spatial' && inputType === 'jobs') {
        <div
        style="
          background-color: white;
          border-radius: 5px;
          margin: 10px 0px 10px;
          padding: 10px;
        "
          >
          <nz-table
            [nzSize]="'small'"
            class="frequency-table styled-table"
            #basicTable
            [nzData]="frequencyData"
            [nzScroll]="{ x: '100%' }"
            >
            <thead>
              <tr>
                <th>Job Name</th>
                <th>Iteration</th>
                <th>Iteration Frequency</th>
                <th>Iters/Block</th>
                <th>Iterations/Block</th>
                <th>Frequency</th>
              </tr>
            </thead>
            <tbody>
              @for (data of basicTable.data; track data) {
                <tr>
                  <td>{{ data.job_name }}</td>
                  <td>{{ data.iteration }}</td>
                  <td>
                    {{
                    data.iteration_frequency
                    ? data.iteration_frequency + "Hz"
                    : ""
                    }}
                  </td>
                  <td>{{ data.iters }}</td>
                  <td>{{ data.iterations }}</td>
                  <td>{{ data.frequency }}</td>
                </tr>
              }
            </tbody>
          </nz-table>
        </div>
      }
    </nz-spin>

    <div class="sidebar-panel" style="width: 300px">
      <div
        style="
          background-color: white;
          border-radius: 5px;
          margin: 0px 0px 10px;
          padding: 10px;
        "
        >
        <ng-container *ngTemplateOutlet="selectJobsTemplate"></ng-container>
      </div>
      <div
        style="
          background-color: white;
          border-radius: 5px;
          padding: 10px;
          margin: 0px 0px 10px;
        "
        >
        <nz-spin [nzSpinning]="this.loadingChart">
          @if (inputType === 'jobs') {
            <nz-tabs [nzSelectedIndex]="0">
              <nz-tab nzTitle="Line Chart">
                <div>
                  <div style="display: flex; justify-content: space-between">
                    Y-Axis Limit

                    <span
                      nz-tooltip
                      [nzTooltipTitle]="
                        'Change limits input mode to ' +
                        (limitsInputModeSlider ? 'text-box' : 'slider')
                      "
                      nz-icon
                      nzType="retweet"
                      nzTheme="outline"
                      class="change-inputs"
                      (click)="limitsInputModeSlider = !limitsInputModeSlider"
                    ></span>
                  </div>

                  @if (limitsInputModeSlider) {
                    <div
                      class="_slider-container"
                      >
                      <span>{{ yMin }}</span>
                      <nz-slider
                        nzRange
                        [nzMin]="yMin"
                        [nzMax]="yMax"
                        [(ngModel)]="ylim"
                        (nzOnAfterChange)="onYlimChanged($event)"
                      ></nz-slider>
                      <span>{{ yMax }}</span>
                    </div>
                  } @else {
                    <div style="display: flex; gap: 10px; align-items: center">
                      <nz-input-number
                        nzSize="small"
                        style="flex-grow: 1"
                        [(ngModel)]="ylim[0]"
                        (nzBlur)="onYlimChanged([ylim[0], ylim[1]])"
                        (keyup.enter)="onYlimChanged([ylim[0], ylim[1]])"
                      ></nz-input-number>
                      <span>~</span>
                      <nz-input-number
                        nzSize="small"
                        style="flex-grow: 1"
                        [(ngModel)]="ylim[1]"
                        (nzBlur)="onYlimChanged([ylim[0], ylim[1]])"
                        (keyup.enter)="onYlimChanged([ylim[0], ylim[1]])"
                      ></nz-input-number>
                    </div>
                  }

                </div>
                <div>
                  X-Axis Limit
                  @if (limitsInputModeSlider) {
                    <div
                      class="_slider-container"
                      >
                      <span>{{ xMin }}</span>
                      <nz-slider
                        nzRange
                        [nzMin]="xMin"
                        [nzMax]="xMax"
                        [(ngModel)]="xlim"
                        (nzOnAfterChange)="onXlimChanged($event)"
                      ></nz-slider>
                      <span>{{ xMax }}</span>
                    </div>
                  } @else {
                    <div style="display: flex; gap: 10px; align-items: center">
                      <nz-input-number
                        nzSize="small"
                        style="flex-grow: 1"
                        [(ngModel)]="xlim[0]"
                        (nzBlur)="onXlimChanged([xlim[0], xlim[1]])"
                        (keyup.enter)="onXlimChanged([xlim[0], xlim[1]])"
                      ></nz-input-number>
                      <span>~</span>
                      <nz-input-number
                        nzSize="small"
                        style="flex-grow: 1"
                        [(ngModel)]="xlim[1]"
                        (nzBlur)="onXlimChanged([xlim[0], xlim[1]])"
                        (keyup.enter)="onXlimChanged([xlim[0], xlim[1]])"
                      ></nz-input-number>
                    </div>
                  }

                </div>
                @if (linePlotXConfig == 'spatial') {
                  <div>
                    <nz-divider
                      style="margin: 10px 0px; border-color: #ddd"
                    ></nz-divider>
                    <div style="display: flex; justify-content: space-between">
                      Iteration
                      <nz-radio-group
                        [(ngModel)]="iteration_type"
                        (ngModelChange)="this.plotLineChart()"
                        >
                        <label nz-radio nzValue="global">Global</label>
                        <label nz-radio nzValue="per-job">Per Job</label>
                      </nz-radio-group>
                    </div>
                    @if (iteration_type == 'global') {
                      <div
                        class="_slider-container"
                        >
                        <span>{{ 0 }}</span>
                        <nz-slider
                          [nzMin]="0"
                          [nzMax]="this.spatial_totalIterations"
                          [(ngModel)]="spatial_iteration"
                          (ngModelChange)="this.plotLineChart()"
                        ></nz-slider>
                        <span>{{ this.spatial_totalIterations }}</span>
                        <nz-input-number
                          [nzMin]="0"
                          [nzMax]="this.spatial_totalIterations"
                          nzSize="small"
                          style="width: 50px"
                          [(ngModel)]="spatial_iteration"
                          (ngModelChange)="this.plotLineChart()"
                        ></nz-input-number>
                      </div>
                    } @else {
                      @for (job of this.jobsSelected; track job) {
                        <div
                          class="_slider-container"
                          >
                          <div
                            nz-tooltip
                            [nzTooltipTitle]="job.job_name"
                            style="display: inline"
                            >
                            {{ job.job_name.substring(0, 10) }}
                          </div>
                          <span>{{ 0 }}</span>
                          <nz-slider
                            [nzMin]="0"
                            [nzMax]="job.iterations"
                            [(ngModel)]="job.currentIteration"
                            (ngModelChange)="this.plotLineChart()"
                          ></nz-slider>
                          <span>{{ job.iterations }}</span>
                          <nz-input-number
                            [nzMin]="0"
                            [nzMax]="job.iterations"
                            nzSize="small"
                            style="width: 50px"
                            [(ngModel)]="job.currentIteration"
                            (ngModelChange)="this.plotLineChart()"
                          ></nz-input-number>
                        </div>
                      }
                    }
                    <nz-divider
                      style="margin: 10px 0px; border-color: #ddd"
                    ></nz-divider>
                  </div>
                }

                @if (!is2d && linePlotXConfig == 'spatial') {
                  <div>
                    <nz-input-group
                      class="legacy-input-styling"
                      style="padding: 0; display: flex"
                      >
                      <label style="left: 10px">Tolerance</label>
                      <input
                        nz-input
                        type="number"
                        noScrollNumber
                        min="1"
                        placeholder="Tolerance"
                        [(ngModel)]="tolerance"
                        />
                      <button
                        nz-button
                        nzType="primary"
                        (click)="this.plotLineChart()"
                        >
                        Update
                      </button>
                    </nz-input-group>
                  </div>
                  <div>
                    <button (click)="swapSpatialAxis()" nz-button nzBlock>
                      <span nz-icon nzType="swap" nzTheme="outline"></span>Swap
                      Axis
                    </button>
                  </div>
                }

                <div>
                  Line Plot X Axis
                  <div>
                    <nz-radio-group
                      [(ngModel)]="linePlotXConfig"
                      (ngModelChange)="this.changePlotType()"
                      >
                      <label nz-radio nzValue="spatial">Spatial</label>
                      <label nz-radio nzValue="iteration">Iteration</label>
                    </nz-radio-group>
                  </div>
                </div>
                @if (linePlotXConfig == 'spatial') {
                  <div
                    style="margin-top: 10px"
                    >
                    Plot Type
                    <div>
                      <nz-radio-group
                        [(ngModel)]="spatial_plotType"
                        (ngModelChange)="this.plotLineChart()"
                        >
                        <label nz-radio nzValue="line">Line</label>
                        <label nz-radio nzValue="scatter">Scatter</label>
                      </nz-radio-group>
                    </div>
                  </div>
                }
                <nz-input-group>
                  <label style="left: 10px">Fit type</label>
                  <nz-select
                    style="width: 100%"
                    nzShowSearch
                    [nzDisabled]="objectKeys(this.data.metrics).length == 0"
                    [nzLoading]="objectKeys(this.data.metrics).length == 0"
                    [(ngModel)]="this.tracetype"
                    (ngModelChange)="plotLineChart()"
                    >
                    @for (metric_type of objectKeys(this.data.metrics); track metric_type) {
                      <nz-option
                        [nzLabel]="this.data.metrics[metric_type]"
                        [nzValue]="metric_type"
                        >
                      </nz-option>
                    }
                  </nz-select>
                </nz-input-group>
              </nz-tab>
            </nz-tabs>
            <!-- <nz-tab nzTitle="Heat Map">
            <nz-collapse nzAccordion style="margin: 10px 0">
              <nz-collapse-panel
                *ngFor="let config of heatmapConfigs; index as i"
                  [nzHeader]="
                    config.x &&
                    config.y &&
                    config.x.value + ' / ' + config.y.value
                  "
                >
                <div>
                  <div
                      style="
                        display: flex;
                        justify-content: space-between;
                        margin: 0 0 10px;
                      "
                    >
                    <button nz-button nzType="primary">Update</button>
                    <button
                      nz-button
                      nzType="dashed"
                        (click)="
                          heatmapAxisSelectionModal = true;
                          activeConfig = i;
                          treeviewInitValue = [
                            heatmapConfigs[activeConfig].x.value,
                            heatmapConfigs[activeConfig].y.value
                          ]
                        "
                      >
                      <span nz-icon nzType="setting" nzTheme="outline"></span>
                    </button>
                  </div>
                  <nz-input-group style="display: flex">
                    <input
                      readonly
                      nz-input
                      style="flex: 1 0 50px"
                      [formControl]="config.x"
                      />
                    <button
                      nz-button
                      nzType="primary"
                      (click)="swapHeatmapAxis(config)"
                      >
                      <span nz-icon nzType="swap" nzTheme="outline"></span>
                    </button>
                    <input
                      readonly
                      nz-input
                      style="flex: 1 0 50px"
                      [formControl]="config.y"
                      />
                  </nz-input-group>
                  <nz-slider
                    nzRange
                    [(ngModel)]="config.colorRange"
                  ></nz-slider>
                </div>
              </nz-collapse-panel>
            </nz-collapse>
            <div>
              <button
                nz-button
                nzType="dashed"
                nzBlock
                (click)="appendHeatmapConfig()"
                >
                Add
              </button>
            </div>
          </nz-tab> -->
          } @else {
            <div style="margin-bottom: 10px">
              <nz-radio-group
                [(ngModel)]="json_chartType"
                (ngModelChange)="plotJsonScatter(true, true)"
                nzButtonStyle="solid"
                nzSize="small"
                style="width: 100%; display: flex"
              >
                <label nz-radio-button nzValue="inline_crossline" style="flex: 1; text-align: center">Inline / Crossline</label>
                <label nz-radio-button nzValue="top_down" style="flex: 1; text-align: center">Top Down</label>
              </nz-radio-group>
            </div>
            <div>
              <div style="display: flex; justify-content: space-between">
                Y-Axis Limit
                <span
                  nz-tooltip
                  [nzTooltipTitle]="'Change limits input mode to ' + (limitsInputModeSlider ? 'text-box' : 'slider')"
                  nz-icon
                  nzType="retweet"
                  nzTheme="outline"
                  class="change-inputs"
                  (click)="limitsInputModeSlider = !limitsInputModeSlider"
                ></span>
              </div>
              @if (limitsInputModeSlider) {
                <div class="_slider-container">
                  <span>{{ yMin }}</span>
                  <nz-slider
                    nzRange
                    [nzMin]="yMin"
                    [nzMax]="yMax"
                    [nzStep]="sliderStep(yMin, yMax)"
                    [(ngModel)]="ylim"
                    (nzOnAfterChange)="onJsonYlimChanged($event)"
                  ></nz-slider>
                  @if (json_chartType === 'inline_crossline') {
                    <span>{{ toSci(yMax) }}</span>
                  } @else {
                    <span>{{ yMax }}</span>
                  }
                </div>
              } @else {
                <div style="display: flex; gap: 10px; align-items: center">
                  <nz-input-number
                    nzSize="small"
                    style="flex-grow: 1"
                    [(ngModel)]="ylim[0]"
                    [nzFormatter]="json_chartType === 'inline_crossline' ? sciFormatter : null"
                    [nzParser]="json_chartType === 'inline_crossline' ? sciParser : null"
                    (nzBlur)="onJsonYlimChanged([ylim[0], ylim[1]])"
                    (keyup.enter)="onJsonYlimChanged([ylim[0], ylim[1]])"
                  ></nz-input-number>
                  <span>~</span>
                  <nz-input-number
                    nzSize="small"
                    style="flex-grow: 1"
                    [(ngModel)]="ylim[1]"
                    [nzFormatter]="json_chartType === 'inline_crossline' ? sciFormatter : null"
                    [nzParser]="json_chartType === 'inline_crossline' ? sciParser : null"
                    (nzBlur)="onJsonYlimChanged([ylim[0], ylim[1]])"
                    (keyup.enter)="onJsonYlimChanged([ylim[0], ylim[1]])"
                  ></nz-input-number>
                </div>
              }
            </div>
            <div>
              X-Axis Limit
              @if (limitsInputModeSlider) {
                <div class="_slider-container">
                  <span>{{ xMin }}</span>
                  <nz-slider
                    nzRange
                    [nzMin]="xMin"
                    [nzMax]="xMax"
                    [nzStep]="sliderStep(xMin, xMax)"
                    [(ngModel)]="xlim"
                    (nzOnAfterChange)="onJsonXlimChanged($event)"
                  ></nz-slider>
                  <span>{{ xMax }}</span>
                </div>
              } @else {
                <div style="display: flex; gap: 10px; align-items: center">
                  <nz-input-number
                    nzSize="small"
                    style="flex-grow: 1"
                    [(ngModel)]="xlim[0]"
                    (nzBlur)="onJsonXlimChanged([xlim[0], xlim[1]])"
                    (keyup.enter)="onJsonXlimChanged([xlim[0], xlim[1]])"
                  ></nz-input-number>
                  <span>~</span>
                  <nz-input-number
                    nzSize="small"
                    style="flex-grow: 1"
                    [(ngModel)]="xlim[1]"
                    (nzBlur)="onJsonXlimChanged([xlim[0], xlim[1]])"
                    (keyup.enter)="onJsonXlimChanged([xlim[0], xlim[1]])"
                  ></nz-input-number>
                </div>
              }
            </div>
            @if (json_chartType === 'inline_crossline') {
              <div>
                <button (click)="swapJsonAxis()" nz-button nzBlock>
                  <span nz-icon nzType="swap" nzTheme="outline"></span>
                  Swap Axis
                </button>
              </div>
            }
            <div style="margin-top: 10px">
              <nz-radio-group
                [(ngModel)]="json_plotType"
                (ngModelChange)="plotJsonScatter(false, false)"
                nzButtonStyle="solid"
                nzSize="small"
                style="width: 100%; display: flex"
              >
                <label nz-radio-button nzValue="scatter" style="flex: 1; text-align: center">Scatter</label>
                <label nz-radio-button nzValue="line" style="flex: 1; text-align: center">Line</label>
              </nz-radio-group>
            </div>
            <div>
              <label style="left: 10px">Fit type</label>
              <nz-select
                style="width: 100%"
                nzShowSearch
                [nzDisabled]="objectKeys(json_metrics).length == 0"
                [nzLoading]="objectKeys(json_metrics).length == 0"
                [(ngModel)]="json_fit_type"
                (ngModelChange)="plotJsonScatter(false, true)"
              >
                @for (key of objectKeys(json_metrics); track key) {
                  <nz-option
                    [nzLabel]="json_metrics[key]"
                    [nzValue]="key"
                  ></nz-option>
                }
              </nz-select>
            </div>
            @if (json_chartType === 'top_down') {
              <div>
                <div style="display: flex; gap: 8px; margin-top: 4px">
                  <div style="flex: 1; display: flex; flex-direction: column">
                    <label style="font-size: 11px; color: #888; margin-bottom: 2px">Min Colour Map</label>
                    <nz-input-number
                      nzSize="small"
                      style="width: 100%"
                      placeholder="Min"
                      [(ngModel)]="json_minFit"
                      [nzFormatter]="sciFormatter"
                      [nzParser]="sciParser"
                      (nzBlur)="plotJsonScatter(false, false)"
                      (keyup.enter)="plotJsonScatter(false, false)"
                    ></nz-input-number>
                  </div>
                  <div style="flex: 1; display: flex; flex-direction: column">
                    <label style="font-size: 11px; color: #888; margin-bottom: 2px">Max Colour Map</label>
                    <nz-input-number
                      nzSize="small"
                      style="width: 100%"
                      placeholder="Max"
                      [(ngModel)]="json_maxFit"
                      [nzFormatter]="sciFormatter"
                      [nzParser]="sciParser"
                      (nzBlur)="plotJsonScatter(false, false)"
                      (keyup.enter)="plotJsonScatter(false, false)"
                    ></nz-input-number>
                  </div>
                </div>
              </div>
            }
          }
        </nz-spin>
      </div>
    </div>
  </div>
</div>

<nz-modal
  nzTitle="Heatmap Configuration"
  [(nzVisible)]="heatmapAxisSelectionModal"
  (nzOnCancel)="heatmapAxisSelectionModal = false"
  (nzOnOk)="heatmapAxisSelectionModal = false"
  [nzMask]="false"
  [nzMaskClosable]="true"
  >
  <ng-container *nzModalContent>
    <div style="display: flex; gap: 10px">
      <div style="width: 300px">
        {{ this.activeConfig }}
        <nz-input-group>
          <input
            readonly
            nz-input
            style="flex: 1 0 50px"
            [formControl]="heatmapConfigs[activeConfig].x"
            />
          <button
            nz-button
            nzType="primary"
            (click)="swapHeatmapAxis(heatmapConfigs[activeConfig])"
            >
            <span nz-icon nzType="swap" nzTheme="outline"></span>
          </button>
          <input
            readonly
            nz-input
            style="flex: 1 0 50px"
            [formControl]="heatmapConfigs[activeConfig].y"
            />
        </nz-input-group>

        <nz-slider
          nzRange
          [(ngModel)]="heatmapConfigs[activeConfig].colorRange"
        ></nz-slider>
        <!-- [formControl]="heatmapConfigs[activeConfig].colorRange" -->
      </div>
      <nz-divider nzType="vertical" style="height: 300px"></nz-divider>
      <div style="height: 300px; width: 300px">
        <app-zorro-treeview
          [maxSelected]="2"
          [treeData]="this.paramViewFields"
          [initValue]="treeviewInitValue"
          (onSelectedChanged)="onParametersChangedForConfig($event)"
        ></app-zorro-treeview>
      </div>
    </div>
  </ng-container>
</nz-modal>

<ng-template #selectJobsTemplate>

  <div style="margin-top: 10px">
    <nz-radio-group
      [(ngModel)]="inputType"
      (ngModelChange)="onInputTypeChange()"
      nzButtonStyle="solid"
      nzSize="small"
      style="width: 100%; margin-bottom: 10px; display: flex"
    >
      <label nz-radio-button nzValue="jobs" style="flex: 1; text-align: center">Jobs</label>
      <label nz-radio-button nzValue="jsonLoad" style="flex: 1; text-align: center">JSON Load</label>
    </nz-radio-group>
  </div>

  @if (inputType === 'jobs') {
    @if (!areFrequenciesComparable) {
      <nz-alert
        nzType="warning"
        nzMessage="Selected jobs use different frequencies."
      ></nz-alert>
    }
    <div
      style="
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
      >
      Select Jobs to plot
      <button nz-button nzType="primary" (click)="plotSelectedJobs()">Plot</button>
    </div>
    <div>
      <button
        nz-button
        nzBlock
        nz-dropdown
        [nzDropdownMenu]="groupsMenu"
        nzTrigger="click"
        [nzClickHide]="false"
        >
        Job Groups
      </button>
    </div>
    <nz-select
      nzShowSearch
      [nzAllowClear]="true"
      nzMode="multiple"
      style="width: 100%; max-height: 250px; overflow-y: scroll"
      nzPlaceHolder="Select Jobs"
      [nzAutoClearSearchValue]="false"
      [(ngModel)]="this.jobsSelectedIds"
      (ngModelChange)="updateJobsSelected($event)"
      >
      @for (job of this.allJobs; track job) {
        <nz-option
          [nzLabel]="job.job_name"
          [nzValue]="job.id"
        ></nz-option>
      }
    </nz-select>
  } @else {
    <div
      style="
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      "
      >
      JSON File Path
      <button nz-button nzType="primary" (click)="plotJsonData()">Plot</button>
    </div>
    <input nz-input placeholder="File Path" [(ngModel)]="file_path" (keyup.enter)="plotJsonData()" />
  }
</ng-template>

<nz-dropdown-menu #groupsMenu="nzDropdownMenu">
  <ul nz-menu>
    @if (jobGroups){
    @for (jobGroup of jobGroups; track jobGroup.id) {
    <li nz-submenu [nzTitle]="jobGroup.name" [nzSelected]="isGroupSelected(jobGroup)"
      (click)="onGroupClick(jobGroup)" [nzClickHide]="false">
      <ul>
        @for (job of jobGroup.jobs; track job) {
        <li nz-menu-item [nzDisabled]="true">
          {{ job.job__job_name }}
        </li>
        }@empty{
          <li nz-menu-item [nzDisabled]="true">No jobs in this group...</li>
        }
      </ul>
    </li>
    }
    }
  </ul>
</nz-dropdown-menu>
